import React, { ReactElement } from 'react';
import { base64UrlEncode } from '../../../utils/utility';
import { useHistory } from 'react-router-dom';
import { ReactComponent as InitiateSettelment } from '../../../assets/images/svg/InitiateSettelmentIcon.svg';
import { ReactComponent as FollowUpMailIcon } from '../../../assets/images/svg/FollowUpMailIcon.svg';
import { actions } from '../../constants/crmConstants';
import { RootState } from '../../../store';
import { useDispatch, useSelector } from 'react-redux';
import '../../../../src/index.less';
import { Popover } from 'antd';
import { customGTMEvent } from '../../../modules/crm/inPatient/service/crmUtils';
import { ApplicationDetailModel } from '../../../store/models/applicationDetailModel';
import { TPA_BANNER_TEXT } from '../../constants/commonConstants';
import { fetchFollowUpDetails, setFollowUpDetailsPayload } from '../../../store/actions/inPatientAction';

const InpatientRenderActions = (props: any): ReactElement => {
  const data = props.data || {};
  const appDetail = useSelector(
    (state: RootState): ApplicationDetailModel => state.applicationDetail,
  );
  const isPreAuthClaimViewEnabled = appDetail?.getIsPreAuthClaimViewEnabled();
  const dispatch = useDispatch();
  const {
    payerClaimNo,
    hospActionId,
    payerId,
    providerId,
    allowStatus,
    productCode,
    isFollowUpEligible,
  } = data;
  const history = useHistory();
  const isNewTpaDeskEnabled = appDetail.getIsNewTpaDeskEnabled();
  const { isInitiateSettelmentBtnClicked, tpaNextStatus, isPreAuthView } =
    useSelector(
      (state: RootState): any => state?.selectedInPatientDetail || {},
    );
  const handleActions = (e: React.MouseEvent<SVGElement>): void => {
    customGTMEvent({
      event: 'Initiate Settlement through Column Actions',
    });
    e.stopPropagation();

    const uniquePayerId = `${payerId}${productCode || ''}`;
    history.push(
      `/claims/in-patient/detail/${base64UrlEncode(
        `${base64UrlEncode(
          payerClaimNo,
        )}/${hospActionId}/${payerId}/${uniquePayerId}/${productCode}/${providerId}`,
      )}/edit/${base64UrlEncode(actions.CASHLESSSUMBIT)}`,
    );
  };

  const handleCancelActions = (e: React.MouseEvent<SVGElement>): any => {
    e.stopPropagation();
    customGTMEvent({
      event: 'Clicked Claim Cancel Actions',
    });
    const uniquePayerId = `${payerId}${productCode || ''}`;
    history.push(
      `/claims/in-patient/detail/${base64UrlEncode(
        `${base64UrlEncode(
          payerClaimNo,
        )}/${hospActionId}/${payerId}/${uniquePayerId}/${productCode}/${providerId}`,
      )}/cancel/${base64UrlEncode(actions.CANCEL)}`,
    );
  };

  const handelFollowUp = (e: any): void => {
    e.stopPropagation();
    const requestPayload = {
      payerClaimNo,
      hospActionId,
      payerId,
      providerId,
      viewType: isPreAuthView ? 'PreAuthView' : 'ClaimView', // Set viewType based on isPreAuthView
    };
    dispatch(setFollowUpDetailsPayload(requestPayload)); // Set the payload for followUp payload for the next followUp api call
    dispatch(fetchFollowUpDetails(requestPayload)); // fetch followup details
  };

  const isStatusPresent = (checkStatus: string, actualStatus: any): boolean => {
    return (
      Array?.isArray(checkStatus) &&
      checkStatus?.some((item: any): any => item?.actionName === actualStatus)
    );
  };
  return (
    <div>
      {isStatusPresent(allowStatus, 'CASHLESSSUMBIT') &&
        (tpaNextStatus === 'AWAITING_SETTLEMENT' ||
          (!isNewTpaDeskEnabled && isPreAuthClaimViewEnabled)) && (
          <div className="inpatient-column-render-actions-icon">
            <Popover
              placement="bottom"
              content={
                <span className="inpatient_render_actions_tooltip">
                  {TPA_BANNER_TEXT.INITIATE_SETLEMENT_TOOLTIP}
                </span>
              }
              trigger="hover"
            >
              <InitiateSettelment
                onClick={handleActions}
                className={`transform-none ${
                  isInitiateSettelmentBtnClicked ? 'expired' : ''
                }`}
              />
            </Popover>
          </div>
        )}

      {/* for followup reminder */}

      {isFollowUpEligible && isNewTpaDeskEnabled && (
        <div className="inpatient-column-render-actions-icon">
          <Popover
            placement="bottom"
            content={
              <span className="inpatient_render_actions_tooltip">
                {TPA_BANNER_TEXT.FOLLOW_UP_REMINDER_TOOLTIP}
              </span>
            }
            trigger="hover"
          >
            <FollowUpMailIcon
              onClick={(e: any): void => handelFollowUp(e)}
              className={`transform-none ${
                isInitiateSettelmentBtnClicked ? 'expired' : ''
              }`}
            />
          </Popover>
        </div>
      )}

      {/* for  cancellation */}

      {isStatusPresent(allowStatus, 'CANCEL') &&
        tpaNextStatus === 'PA_UTILIZATION_PENDING' &&
        isNewTpaDeskEnabled &&
        isPreAuthClaimViewEnabled && (
          <div className="inpatient-column-render-actions-icon">
            <Popover
              placement="bottom"
              content={
                <div>
                  <div className="tpa-popover-header">
                    {TPA_BANNER_TEXT.CANCEL_PA_TOOL_TIP_TITLE}
                  </div>
                  <hr className="tpa-popover-hr-line" />
                  <div className="tpa-popover-content">
                    {TPA_BANNER_TEXT.CANCEL_PA_TOOL_TIP_CONTENT}
                  </div>
                </div>
              }
              trigger="hover"
            >
              <div
                onClick={(e: any): void => handleCancelActions(e)}
                className="cancel-in-action"
              >
                {TPA_BANNER_TEXT.CANCEL_TITLE}
              </div>
            </Popover>
          </div>
        )}
    </div>
  );
};

export default InpatientRenderActions;
